module.exports = __webpack_public_path__ + "static/media/partnership-rgb-blue-nt.df7d8f13.png";